export default "__VITE_ASSET__Cs4JnptY__"